import React, { useEffect, useRef, useState } from 'react';

export default function ExpiredNotice({ open, onConfirm, onTimeout, durationMs = 15000 }) {
  const [remainingMs, setRemainingMs] = useState(durationMs);
  const intervalRef = useRef(null);
  const timeoutRef = useRef(null);

  useEffect(() => {
    if (!open) return () => {};
    setRemainingMs(durationMs);
    // Tick every 250ms for a smooth countdown
    intervalRef.current = setInterval(() => {
      setRemainingMs((prev) => Math.max(0, prev - 250));
    }, 250);
    timeoutRef.current = setTimeout(() => {
      if (typeof onTimeout === 'function') onTimeout();
    }, durationMs);
    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
      intervalRef.current = null;
      timeoutRef.current = null;
    };
  }, [open, durationMs, onTimeout]);

  if (!open) return null;

  const seconds = Math.ceil(remainingMs / 1000);

  return (
    <div className="expired-toast" role="dialog" aria-live="polite" aria-label="Room expired notice">
      <div className="expired-toast-inner">
        <div className="expired-toast-emoji" aria-hidden="true">🎉</div>
        <div className="expired-toast-content">
          <div className="expired-toast-title">Room expired, thanks for playing!</div>
          <div className="expired-toast-text">We hope you had fun deciding together. You’ll be returned to the lobby in {seconds}s.</div>
        </div>
        <button
          type="button"
          className="control-button expired-toast-button"
          onClick={onConfirm}
          aria-label="Return to lobby now"
        >
          OK
        </button>
      </div>
    </div>
  );
}
